/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassSignupAvailabilityStatus,
  ClassSignupAvailabilityStatusOptional,
  ClassSignupAvailabilityStatusMetaI,
  ClassSignupAvailabilityStatusTrackedI,
} from "./class-signup-availability-status";
import {
  ClassSignupAvailabilityStatusTracked,
  ClassSignupAvailabilityStatusMeta,
} from "./class-signup-availability-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PricingInformationDTO,
  PricingInformationDTOOptional,
  PricingInformationDTOMetaI,
  PricingInformationDTOTrackedI,
} from "./pricing-information-dto";
import {
  PricingInformationDTOTracked,
  PricingInformationDTOMeta,
} from "./pricing-information-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  SignupTypeEnum,
  SignupTypeEnumOptional,
  SignupTypeEnumMetaI,
  SignupTypeEnumTrackedI,
} from "./signup-type-enum";
import { SignupTypeEnumTracked, SignupTypeEnumMeta } from "./signup-type-enum";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassStaggerRef,
  UnifiedClassStaggerRefOptional,
  UnifiedClassStaggerRefMetaI,
  UnifiedClassStaggerRefTrackedI,
} from "./unified-class-stagger-ref";
import {
  UnifiedClassStaggerRefTracked,
  UnifiedClassStaggerRefMeta,
} from "./unified-class-stagger-ref";

/**
 *
 * @export
 * @interface ClassAvailabilityDTO
 */
export interface ClassAvailabilityDTOOptional {
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  totalSlots?: number;
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  enrolled?: number;
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  waitlisted?: number;
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  waitlistResultsExpired?: number;
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  waitlistResultsFailed?: number;
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  availableSlots?: number;
  /**
   *
   * @type {string}
   * @memberof ClassAvailabilityDTO
   */
  availableOn?: Date;
  /**
   *
   * @type {ClassSignupAvailabilityStatus}
   * @memberof ClassAvailabilityDTO
   */
  availabilityStatus?: ClassSignupAvailabilityStatus;
  /**
   *
   * @type {boolean}
   * @memberof ClassAvailabilityDTO
   */
  allowWaitlist?: boolean;
  /**
   *
   * @type {PricingInformationDTO}
   * @memberof ClassAvailabilityDTO
   */
  pricingInformation?: PricingInformationDTOOptional;
  /**
   *
   * @type {UnifiedClassStaggerRef}
   * @memberof ClassAvailabilityDTO
   */
  currentStaggerId?: UnifiedClassStaggerRefOptional;
  /**
   *
   * @type {boolean}
   * @memberof ClassAvailabilityDTO
   */
  isLastStagger?: boolean;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof ClassAvailabilityDTO
   */
  waitlistedEnrollAction?: SignupTypeEnum;
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  currentSignupSequence?: number;
}

export interface ClassAvailabilityDTO extends ClassAvailabilityDTOOptional {
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  totalSlots?: number;
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  enrolled?: number;
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  waitlisted?: number;
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  waitlistResultsExpired?: number;
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  waitlistResultsFailed?: number;
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  availableSlots?: number;
  /**
   *
   * @type {string}
   * @memberof ClassAvailabilityDTO
   */
  availableOn?: Date;
  /**
   *
   * @type {ClassSignupAvailabilityStatus}
   * @memberof ClassAvailabilityDTO
   */
  availabilityStatus?: ClassSignupAvailabilityStatus;
  /**
   *
   * @type {boolean}
   * @memberof ClassAvailabilityDTO
   */
  allowWaitlist?: boolean;
  /**
   *
   * @type {PricingInformationDTO}
   * @memberof ClassAvailabilityDTO
   */
  pricingInformation?: PricingInformationDTO;
  /**
   *
   * @type {UnifiedClassStaggerRef}
   * @memberof ClassAvailabilityDTO
   */
  currentStaggerId?: UnifiedClassStaggerRef;
  /**
   *
   * @type {boolean}
   * @memberof ClassAvailabilityDTO
   */
  isLastStagger?: boolean;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof ClassAvailabilityDTO
   */
  waitlistedEnrollAction?: SignupTypeEnum;
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  currentSignupSequence?: number;
}

export interface ClassAvailabilityDTOTrackedI {
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  totalSlots?: number;
  totalSlotsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  enrolled?: number;
  enrolledIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  waitlisted?: number;
  waitlistedIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  waitlistResultsExpired?: number;
  waitlistResultsExpiredIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  waitlistResultsFailed?: number;
  waitlistResultsFailedIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  availableSlots?: number;
  availableSlotsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassAvailabilityDTO
   */
  availableOn?: Date;
  availableOnIsSet: boolean;
  /**
   *
   * @type {ClassSignupAvailabilityStatus}
   * @memberof ClassAvailabilityDTO
   */
  availabilityStatus?: ClassSignupAvailabilityStatus;
  availabilityStatusIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassAvailabilityDTO
   */
  allowWaitlist?: boolean;
  allowWaitlistIsSet: boolean;
  /**
   *
   * @type {PricingInformationDTO}
   * @memberof ClassAvailabilityDTO
   */
  pricingInformation?: PricingInformationDTOTrackedI;
  pricingInformationIsSet: boolean;
  /**
   *
   * @type {UnifiedClassStaggerRef}
   * @memberof ClassAvailabilityDTO
   */
  currentStaggerId?: UnifiedClassStaggerRefTrackedI;
  currentStaggerIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassAvailabilityDTO
   */
  isLastStagger?: boolean;
  isLastStaggerIsSet: boolean;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof ClassAvailabilityDTO
   */
  waitlistedEnrollAction?: SignupTypeEnum;
  waitlistedEnrollActionIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassAvailabilityDTO
   */
  currentSignupSequence?: number;
  currentSignupSequenceIsSet: boolean;
}

transformDatesMap.set(
  "ClassAvailabilityDTO",
  function (model: ClassAvailabilityDTO) {
    if (typeof model.availableOn == "string")
      model.availableOn = new Date(model.availableOn);
    const transformDatespricingInformation = transformDatesMap.get(
      "PricingInformationDTO",
    );
    if (transformDatespricingInformation && model.pricingInformation) {
      transformDatespricingInformation(model.pricingInformation);
    }
    const transformDatescurrentStaggerId = transformDatesMap.get(
      "UnifiedClassStaggerRef",
    );
    if (transformDatescurrentStaggerId && model.currentStaggerId) {
      transformDatescurrentStaggerId(model.currentStaggerId);
    }
  },
);

export type ClassAvailabilityDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  totalSlots: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  enrolled: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  waitlisted: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  waitlistResultsExpired: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  waitlistResultsFailed: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  availableSlots: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  availableOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  availabilityStatus: PropertyMeta<ClassSignupAvailabilityStatusMetaI>;
  //isDate: false
  //isDatetime: false
  allowWaitlist: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  pricingInformation: PropertyMeta<PricingInformationDTOMetaI>;
  //isDate: false
  //isDatetime: false
  currentStaggerId: PropertyMeta<UnifiedClassStaggerRefMetaI>;
  //isDate: false
  //isDatetime: false
  isLastStagger: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  waitlistedEnrollAction: PropertyMeta<SignupTypeEnumMetaI>;
  //isDate: false
  //isDatetime: false
  currentSignupSequence: PropertyMeta<MetaTypeBase<number>>;
}>;

export var ClassAvailabilityDTOMeta: ClassAvailabilityDTOMetaI =
  {} as ClassAvailabilityDTOMetaI;
ClassAvailabilityDTOMeta = typeMeta("ClassAvailabilityDTO", {
  totalSlots: propertyMeta(
    "totalSlots",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  enrolled: propertyMeta("enrolled", false, false, false, MetaTypesBase.number),
  waitlisted: propertyMeta(
    "waitlisted",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  waitlistResultsExpired: propertyMeta(
    "waitlistResultsExpired",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  waitlistResultsFailed: propertyMeta(
    "waitlistResultsFailed",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  availableSlots: propertyMeta(
    "availableSlots",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  availableOn: propertyMeta(
    "availableOn",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  availabilityStatus: propertyMeta(
    "availabilityStatus",
    false,
    false,
    false,
    ClassSignupAvailabilityStatusMeta,
  ),
  allowWaitlist: propertyMeta(
    "allowWaitlist",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  pricingInformation: propertyMeta(
    "pricingInformation",
    false,
    false,
    false,
    PricingInformationDTOMeta,
  ),
  currentStaggerId: propertyMeta(
    "currentStaggerId",
    false,
    false,
    false,
    UnifiedClassStaggerRefMeta,
  ),
  isLastStagger: propertyMeta(
    "isLastStagger",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  waitlistedEnrollAction: propertyMeta(
    "waitlistedEnrollAction",
    false,
    false,
    false,
    SignupTypeEnumMeta,
  ),
  currentSignupSequence: propertyMeta(
    "currentSignupSequence",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = ClassAvailabilityDTOMeta;

registerMeta(() => {});

export class ClassAvailabilityDTOTracked implements ClassAvailabilityDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  totalSlots__I?: number = undefined;
  totalSlotsIsSet: boolean = false;
  set totalSlots(v: undefined | number) {
    if (v !== undefined) {
      this.totalSlots__I = v;
      this.totalSlotsIsSet = true;
    } else {
      this.totalSlots__I = v || undefined;
      this.totalSlotsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalSlots() {
    return this.totalSlots__I;
  }
  enrolled__I?: number = undefined;
  enrolledIsSet: boolean = false;
  set enrolled(v: undefined | number) {
    if (v !== undefined) {
      this.enrolled__I = v;
      this.enrolledIsSet = true;
    } else {
      this.enrolled__I = v || undefined;
      this.enrolledIsSet = false;
    }
    this.changeTracker = true;
  }
  get enrolled() {
    return this.enrolled__I;
  }
  waitlisted__I?: number = undefined;
  waitlistedIsSet: boolean = false;
  set waitlisted(v: undefined | number) {
    if (v !== undefined) {
      this.waitlisted__I = v;
      this.waitlistedIsSet = true;
    } else {
      this.waitlisted__I = v || undefined;
      this.waitlistedIsSet = false;
    }
    this.changeTracker = true;
  }
  get waitlisted() {
    return this.waitlisted__I;
  }
  waitlistResultsExpired__I?: number = undefined;
  waitlistResultsExpiredIsSet: boolean = false;
  set waitlistResultsExpired(v: undefined | number) {
    if (v !== undefined) {
      this.waitlistResultsExpired__I = v;
      this.waitlistResultsExpiredIsSet = true;
    } else {
      this.waitlistResultsExpired__I = v || undefined;
      this.waitlistResultsExpiredIsSet = false;
    }
    this.changeTracker = true;
  }
  get waitlistResultsExpired() {
    return this.waitlistResultsExpired__I;
  }
  waitlistResultsFailed__I?: number = undefined;
  waitlistResultsFailedIsSet: boolean = false;
  set waitlistResultsFailed(v: undefined | number) {
    if (v !== undefined) {
      this.waitlistResultsFailed__I = v;
      this.waitlistResultsFailedIsSet = true;
    } else {
      this.waitlistResultsFailed__I = v || undefined;
      this.waitlistResultsFailedIsSet = false;
    }
    this.changeTracker = true;
  }
  get waitlistResultsFailed() {
    return this.waitlistResultsFailed__I;
  }
  availableSlots__I?: number = undefined;
  availableSlotsIsSet: boolean = false;
  set availableSlots(v: undefined | number) {
    if (v !== undefined) {
      this.availableSlots__I = v;
      this.availableSlotsIsSet = true;
    } else {
      this.availableSlots__I = v || undefined;
      this.availableSlotsIsSet = false;
    }
    this.changeTracker = true;
  }
  get availableSlots() {
    return this.availableSlots__I;
  }
  availableOn__I?: Date = undefined;
  availableOnIsSet: boolean = false;
  set availableOn(v: undefined | Date) {
    if (v !== undefined) {
      this.availableOn__I = v;
      this.availableOnIsSet = true;
    } else {
      this.availableOn__I = v || undefined;
      this.availableOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get availableOn() {
    return this.availableOn__I;
  }
  availabilityStatus__I?: ClassSignupAvailabilityStatus = undefined;
  availabilityStatusIsSet: boolean = false;
  set availabilityStatus(v: undefined | ClassSignupAvailabilityStatus) {
    if (v !== undefined) {
      this.availabilityStatus__I = v;
      this.availabilityStatusIsSet = true;
    } else {
      this.availabilityStatus__I = v || undefined;
      this.availabilityStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get availabilityStatus() {
    return this.availabilityStatus__I;
  }
  allowWaitlist__I?: boolean = undefined;
  allowWaitlistIsSet: boolean = false;
  set allowWaitlist(v: undefined | boolean) {
    if (v !== undefined) {
      this.allowWaitlist__I = v;
      this.allowWaitlistIsSet = true;
    } else {
      this.allowWaitlist__I = v || undefined;
      this.allowWaitlistIsSet = false;
    }
    this.changeTracker = true;
  }
  get allowWaitlist() {
    return this.allowWaitlist__I;
  }
  pricingInformation__I?: PricingInformationDTOTracked = undefined;
  pricingInformationIsSet: boolean = false;
  set pricingInformation(v: undefined | PricingInformationDTOTracked) {
    if (v !== undefined) {
      this.pricingInformation__I = v;
      this.pricingInformationIsSet = true;
    } else {
      this.pricingInformation__I = v || undefined;
      this.pricingInformationIsSet = false;
    }
    this.changeTracker = true;
  }
  get pricingInformation() {
    return this.pricingInformation__I;
  }
  currentStaggerId__I?: UnifiedClassStaggerRefTracked = undefined;
  currentStaggerIdIsSet: boolean = false;
  set currentStaggerId(v: undefined | UnifiedClassStaggerRefTracked) {
    if (v !== undefined) {
      this.currentStaggerId__I = v;
      this.currentStaggerIdIsSet = true;
    } else {
      this.currentStaggerId__I = v || undefined;
      this.currentStaggerIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get currentStaggerId() {
    return this.currentStaggerId__I;
  }
  isLastStagger__I?: boolean = undefined;
  isLastStaggerIsSet: boolean = false;
  set isLastStagger(v: undefined | boolean) {
    if (v !== undefined) {
      this.isLastStagger__I = v;
      this.isLastStaggerIsSet = true;
    } else {
      this.isLastStagger__I = v || undefined;
      this.isLastStaggerIsSet = false;
    }
    this.changeTracker = true;
  }
  get isLastStagger() {
    return this.isLastStagger__I;
  }
  waitlistedEnrollAction__I?: SignupTypeEnum = undefined;
  waitlistedEnrollActionIsSet: boolean = false;
  set waitlistedEnrollAction(v: undefined | SignupTypeEnum) {
    if (v !== undefined) {
      this.waitlistedEnrollAction__I = v;
      this.waitlistedEnrollActionIsSet = true;
    } else {
      this.waitlistedEnrollAction__I = v || undefined;
      this.waitlistedEnrollActionIsSet = false;
    }
    this.changeTracker = true;
  }
  get waitlistedEnrollAction() {
    return this.waitlistedEnrollAction__I;
  }
  currentSignupSequence__I?: number = undefined;
  currentSignupSequenceIsSet: boolean = false;
  set currentSignupSequence(v: undefined | number) {
    if (v !== undefined) {
      this.currentSignupSequence__I = v;
      this.currentSignupSequenceIsSet = true;
    } else {
      this.currentSignupSequence__I = v || undefined;
      this.currentSignupSequenceIsSet = false;
    }
    this.changeTracker = true;
  }
  get currentSignupSequence() {
    return this.currentSignupSequence__I;
  }
  constructor(config?: ClassAvailabilityDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.pricingInformation?.setIds();

    this.currentStaggerId?.setIds();
  }
  assignFrom(
    config: ClassAvailabilityDTOOptional,
    options?: AssignOptions,
  ): ClassAvailabilityDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.totalSlots &&
      this.totalSlotsApplyFilter(optionsRequired.filter)
    ) {
      this.totalSlots = config.totalSlots;
      if (optionsRequired.unassign) this.totalSlotsIsSet = false;
      else this.totalSlotsIsSet = true;
    }
    if (config.enrolled && this.enrolledApplyFilter(optionsRequired.filter)) {
      this.enrolled = config.enrolled;
      if (optionsRequired.unassign) this.enrolledIsSet = false;
      else this.enrolledIsSet = true;
    }
    if (
      config.waitlisted &&
      this.waitlistedApplyFilter(optionsRequired.filter)
    ) {
      this.waitlisted = config.waitlisted;
      if (optionsRequired.unassign) this.waitlistedIsSet = false;
      else this.waitlistedIsSet = true;
    }
    if (
      config.waitlistResultsExpired &&
      this.waitlistResultsExpiredApplyFilter(optionsRequired.filter)
    ) {
      this.waitlistResultsExpired = config.waitlistResultsExpired;
      if (optionsRequired.unassign) this.waitlistResultsExpiredIsSet = false;
      else this.waitlistResultsExpiredIsSet = true;
    }
    if (
      config.waitlistResultsFailed &&
      this.waitlistResultsFailedApplyFilter(optionsRequired.filter)
    ) {
      this.waitlistResultsFailed = config.waitlistResultsFailed;
      if (optionsRequired.unassign) this.waitlistResultsFailedIsSet = false;
      else this.waitlistResultsFailedIsSet = true;
    }
    if (
      config.availableSlots &&
      this.availableSlotsApplyFilter(optionsRequired.filter)
    ) {
      this.availableSlots = config.availableSlots;
      if (optionsRequired.unassign) this.availableSlotsIsSet = false;
      else this.availableSlotsIsSet = true;
    }
    if (
      config.availableOn &&
      this.availableOnApplyFilter(optionsRequired.filter)
    ) {
      this.availableOn = config.availableOn;
      if (optionsRequired.unassign) this.availableOnIsSet = false;
      else this.availableOnIsSet = true;
    }
    if (
      config.availabilityStatus &&
      this.availabilityStatusApplyFilter(optionsRequired.filter)
    ) {
      this.availabilityStatus = config.availabilityStatus;
      if (optionsRequired.unassign) this.availabilityStatusIsSet = false;
      else this.availabilityStatusIsSet = true;
    }
    if (
      config.allowWaitlist &&
      this.allowWaitlistApplyFilter(optionsRequired.filter)
    ) {
      this.allowWaitlist = config.allowWaitlist;
      if (optionsRequired.unassign) this.allowWaitlistIsSet = false;
      else this.allowWaitlistIsSet = true;
    }
    if (
      config.pricingInformation &&
      this.pricingInformationApplyFilter(optionsRequired.filter)
    ) {
      this.pricingInformation = new PricingInformationDTOTracked(
        config.pricingInformation,
        options,
      );
      if (optionsRequired.unassign) this.pricingInformationIsSet = false;
      else this.pricingInformationIsSet = true;
    }
    if (
      config.currentStaggerId &&
      this.currentStaggerIdApplyFilter(optionsRequired.filter)
    ) {
      this.currentStaggerId = new UnifiedClassStaggerRefTracked(
        config.currentStaggerId,
        options,
      );
      if (optionsRequired.unassign) this.currentStaggerIdIsSet = false;
      else this.currentStaggerIdIsSet = true;
    }
    if (
      config.isLastStagger &&
      this.isLastStaggerApplyFilter(optionsRequired.filter)
    ) {
      this.isLastStagger = config.isLastStagger;
      if (optionsRequired.unassign) this.isLastStaggerIsSet = false;
      else this.isLastStaggerIsSet = true;
    }
    if (
      config.waitlistedEnrollAction &&
      this.waitlistedEnrollActionApplyFilter(optionsRequired.filter)
    ) {
      this.waitlistedEnrollAction = config.waitlistedEnrollAction;
      if (optionsRequired.unassign) this.waitlistedEnrollActionIsSet = false;
      else this.waitlistedEnrollActionIsSet = true;
    }
    if (
      config.currentSignupSequence &&
      this.currentSignupSequenceApplyFilter(optionsRequired.filter)
    ) {
      this.currentSignupSequence = config.currentSignupSequence;
      if (optionsRequired.unassign) this.currentSignupSequenceIsSet = false;
      else this.currentSignupSequenceIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ClassAvailabilityDTOTrackedI {
    const cloned = {} as ClassAvailabilityDTOTrackedI;
    if (
      this.totalSlotsIsSetDeep() &&
      this.totalSlotsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalSlotsIsSet = true;
      cloned.totalSlots = this.totalSlots;
    } else {
      //cloned.totalSlotsIsSet = false
    }
    if (
      this.enrolledIsSetDeep() &&
      this.enrolledApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.enrolledIsSet = true;
      cloned.enrolled = this.enrolled;
    } else {
      //cloned.enrolledIsSet = false
    }
    if (
      this.waitlistedIsSetDeep() &&
      this.waitlistedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.waitlistedIsSet = true;
      cloned.waitlisted = this.waitlisted;
    } else {
      //cloned.waitlistedIsSet = false
    }
    if (
      this.waitlistResultsExpiredIsSetDeep() &&
      this.waitlistResultsExpiredApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.waitlistResultsExpiredIsSet = true;
      cloned.waitlistResultsExpired = this.waitlistResultsExpired;
    } else {
      //cloned.waitlistResultsExpiredIsSet = false
    }
    if (
      this.waitlistResultsFailedIsSetDeep() &&
      this.waitlistResultsFailedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.waitlistResultsFailedIsSet = true;
      cloned.waitlistResultsFailed = this.waitlistResultsFailed;
    } else {
      //cloned.waitlistResultsFailedIsSet = false
    }
    if (
      this.availableSlotsIsSetDeep() &&
      this.availableSlotsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.availableSlotsIsSet = true;
      cloned.availableSlots = this.availableSlots;
    } else {
      //cloned.availableSlotsIsSet = false
    }
    if (
      this.availableOnIsSetDeep() &&
      this.availableOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.availableOnIsSet = true;
      cloned.availableOn = this.availableOn;
    } else {
      //cloned.availableOnIsSet = false
    }
    if (
      this.availabilityStatusIsSetDeep() &&
      this.availabilityStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.availabilityStatusIsSet = true;
      cloned.availabilityStatus = this.availabilityStatus;
    } else {
      //cloned.availabilityStatusIsSet = false
    }
    if (
      this.allowWaitlistIsSetDeep() &&
      this.allowWaitlistApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.allowWaitlistIsSet = true;
      cloned.allowWaitlist = this.allowWaitlist;
    } else {
      //cloned.allowWaitlistIsSet = false
    }
    if (
      this.pricingInformationIsSetDeep() &&
      this.pricingInformationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.pricingInformationIsSet = true;
      cloned.pricingInformation = this.pricingInformation?.removeUnset(filter);
    } else {
      //cloned.pricingInformationIsSet = false
    }
    if (
      this.currentStaggerIdIsSetDeep() &&
      this.currentStaggerIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.currentStaggerIdIsSet = true;
      cloned.currentStaggerId = this.currentStaggerId?.removeUnset(filter);
    } else {
      //cloned.currentStaggerIdIsSet = false
    }
    if (
      this.isLastStaggerIsSetDeep() &&
      this.isLastStaggerApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isLastStaggerIsSet = true;
      cloned.isLastStagger = this.isLastStagger;
    } else {
      //cloned.isLastStaggerIsSet = false
    }
    if (
      this.waitlistedEnrollActionIsSetDeep() &&
      this.waitlistedEnrollActionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.waitlistedEnrollActionIsSet = true;
      cloned.waitlistedEnrollAction = this.waitlistedEnrollAction;
    } else {
      //cloned.waitlistedEnrollActionIsSet = false
    }
    if (
      this.currentSignupSequenceIsSetDeep() &&
      this.currentSignupSequenceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.currentSignupSequenceIsSet = true;
      cloned.currentSignupSequence = this.currentSignupSequence;
    } else {
      //cloned.currentSignupSequenceIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ClassAvailabilityDTOTrackedI {
    if (!this.totalSlotsApplyFilter(filter)) this.totalSlotsIsSet = false;

    if (!this.enrolledApplyFilter(filter)) this.enrolledIsSet = false;

    if (!this.waitlistedApplyFilter(filter)) this.waitlistedIsSet = false;

    if (!this.waitlistResultsExpiredApplyFilter(filter))
      this.waitlistResultsExpiredIsSet = false;

    if (!this.waitlistResultsFailedApplyFilter(filter))
      this.waitlistResultsFailedIsSet = false;

    if (!this.availableSlotsApplyFilter(filter))
      this.availableSlotsIsSet = false;

    if (!this.availableOnApplyFilter(filter)) this.availableOnIsSet = false;

    if (!this.availabilityStatusApplyFilter(filter))
      this.availabilityStatusIsSet = false;

    if (!this.allowWaitlistApplyFilter(filter)) this.allowWaitlistIsSet = false;

    if (!this.pricingInformationApplyFilter(filter))
      this.pricingInformationIsSet = false;
    this.pricingInformation?.unassignAll(filter);

    if (!this.currentStaggerIdApplyFilter(filter))
      this.currentStaggerIdIsSet = false;
    this.currentStaggerId?.unassignAll(filter);

    if (!this.isLastStaggerApplyFilter(filter)) this.isLastStaggerIsSet = false;

    if (!this.waitlistedEnrollActionApplyFilter(filter))
      this.waitlistedEnrollActionIsSet = false;

    if (!this.currentSignupSequenceApplyFilter(filter))
      this.currentSignupSequenceIsSet = false;

    return this;
  }
  totalSlotsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassAvailabilityDTOMeta.totalSlots,
      ClassAvailabilityDTOMeta,
      this.totalSlots,
      this,
    );
  }
  totalSlotsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.totalSlotsIsSet && this.totalSlotsApplyFilter(filter)) return true;

    return false;
  }
  enrolledApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassAvailabilityDTOMeta.enrolled,
      ClassAvailabilityDTOMeta,
      this.enrolled,
      this,
    );
  }
  enrolledIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.enrolledIsSet && this.enrolledApplyFilter(filter)) return true;

    return false;
  }
  waitlistedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassAvailabilityDTOMeta.waitlisted,
      ClassAvailabilityDTOMeta,
      this.waitlisted,
      this,
    );
  }
  waitlistedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.waitlistedIsSet && this.waitlistedApplyFilter(filter)) return true;

    return false;
  }
  waitlistResultsExpiredApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassAvailabilityDTOMeta.waitlistResultsExpired,
      ClassAvailabilityDTOMeta,
      this.waitlistResultsExpired,
      this,
    );
  }
  waitlistResultsExpiredIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.waitlistResultsExpiredIsSet &&
      this.waitlistResultsExpiredApplyFilter(filter)
    )
      return true;

    return false;
  }
  waitlistResultsFailedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassAvailabilityDTOMeta.waitlistResultsFailed,
      ClassAvailabilityDTOMeta,
      this.waitlistResultsFailed,
      this,
    );
  }
  waitlistResultsFailedIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.waitlistResultsFailedIsSet &&
      this.waitlistResultsFailedApplyFilter(filter)
    )
      return true;

    return false;
  }
  availableSlotsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassAvailabilityDTOMeta.availableSlots,
      ClassAvailabilityDTOMeta,
      this.availableSlots,
      this,
    );
  }
  availableSlotsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.availableSlotsIsSet && this.availableSlotsApplyFilter(filter))
      return true;

    return false;
  }
  availableOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassAvailabilityDTOMeta.availableOn,
      ClassAvailabilityDTOMeta,
      this.availableOn,
      this,
    );
  }
  availableOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.availableOnIsSet && this.availableOnApplyFilter(filter))
      return true;

    return false;
  }
  availabilityStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassAvailabilityDTOMeta.availabilityStatus,
      ClassAvailabilityDTOMeta,
      this.availabilityStatus,
      this,
    );
  }
  availabilityStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.availabilityStatusIsSet &&
      this.availabilityStatusApplyFilter(filter)
    )
      return true;

    return false;
  }
  allowWaitlistApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassAvailabilityDTOMeta.allowWaitlist,
      ClassAvailabilityDTOMeta,
      this.allowWaitlist,
      this,
    );
  }
  allowWaitlistIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.allowWaitlistIsSet && this.allowWaitlistApplyFilter(filter))
      return true;

    return false;
  }
  pricingInformationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassAvailabilityDTOMeta.pricingInformation,
      ClassAvailabilityDTOMeta,
      this.pricingInformation,
      this,
    );
  }
  pricingInformationIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.pricingInformationIsSet &&
      this.pricingInformationApplyFilter(filter)
    )
      return true;
    return this.pricingInformation?.anySet(filter) == true;

    return false;
  }
  currentStaggerIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassAvailabilityDTOMeta.currentStaggerId,
      ClassAvailabilityDTOMeta,
      this.currentStaggerId,
      this,
    );
  }
  currentStaggerIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.currentStaggerIdIsSet && this.currentStaggerIdApplyFilter(filter))
      return true;
    return this.currentStaggerId?.anySet(filter) == true;

    return false;
  }
  isLastStaggerApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassAvailabilityDTOMeta.isLastStagger,
      ClassAvailabilityDTOMeta,
      this.isLastStagger,
      this,
    );
  }
  isLastStaggerIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isLastStaggerIsSet && this.isLastStaggerApplyFilter(filter))
      return true;

    return false;
  }
  waitlistedEnrollActionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassAvailabilityDTOMeta.waitlistedEnrollAction,
      ClassAvailabilityDTOMeta,
      this.waitlistedEnrollAction,
      this,
    );
  }
  waitlistedEnrollActionIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.waitlistedEnrollActionIsSet &&
      this.waitlistedEnrollActionApplyFilter(filter)
    )
      return true;

    return false;
  }
  currentSignupSequenceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassAvailabilityDTOMeta.currentSignupSequence,
      ClassAvailabilityDTOMeta,
      this.currentSignupSequence,
      this,
    );
  }
  currentSignupSequenceIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.currentSignupSequenceIsSet &&
      this.currentSignupSequenceApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.totalSlotsIsSetDeep(filter)) return true;
    if (this.enrolledIsSetDeep(filter)) return true;
    if (this.waitlistedIsSetDeep(filter)) return true;
    if (this.waitlistResultsExpiredIsSetDeep(filter)) return true;
    if (this.waitlistResultsFailedIsSetDeep(filter)) return true;
    if (this.availableSlotsIsSetDeep(filter)) return true;
    if (this.availableOnIsSetDeep(filter)) return true;
    if (this.availabilityStatusIsSetDeep(filter)) return true;
    if (this.allowWaitlistIsSetDeep(filter)) return true;
    if (this.pricingInformationIsSetDeep(filter)) return true;
    if (this.currentStaggerIdIsSetDeep(filter)) return true;
    if (this.isLastStaggerIsSetDeep(filter)) return true;
    if (this.waitlistedEnrollActionIsSetDeep(filter)) return true;
    if (this.currentSignupSequenceIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
